import { render, staticRenderFns } from "./PurchasedRetail.vue?vue&type=template&id=24771b3f&scoped=true&"
import script from "./PurchasedRetail.vue?vue&type=script&lang=js&"
export * from "./PurchasedRetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedRetail.vue?vue&type=style&index=0&id=24771b3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24771b3f",
  null
  
)

export default component.exports